import { render, staticRenderFns } from "./VHistoryItem.vue?vue&type=template&id=bd8a9fd2&"
import script from "./VHistoryItem.vue?vue&type=script&lang=ts&"
export * from "./VHistoryItem.vue?vue&type=script&lang=ts&"
import style0 from "./VHistoryItem.vue?vue&type=style&index=0&id=bd8a9fd2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports